import { subMinutes } from "date-fns";

export function fromUtc(date: Date): Date {
    return subMinutes(date, date.getTimezoneOffset());
}
